<template>
    <b-navbar toggleable="lg" fixed="top" sticky=true type="dark" variant="dark" >
    <b-container class="bg-dark">
        <b-navbar-brand class="m-3" href="#">{{ brand }}</b-navbar-brand>
            <b-navbar-nav class="m-3 ml-auto">
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-collapse id="nav-collapse" is-nav>
                        <b-nav-item to="#wie-ben-ik">Wie ben ik?</b-nav-item>
                        <b-nav-item to="#kies-je-training">Kies je training</b-nav-item>
                        <b-nav-item to="#impact-x">Impact X</b-nav-item>
                        <b-nav-item to="#contact">Contact</b-nav-item>
                    </b-collapse>
            </b-navbar-nav>
    </b-container>
    </b-navbar>

</template>

<script>
export default {
    name: 'NavBar',
    props: {
        brand: String
    }
}
</script>